import styled from 'styled-components';

// The line under the select: spaced off it, with the info icon sitting next to the text.
const ReceivesRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0 4px;
`;

const InfoIconWrapper = styled.span`
  display: inline-flex;
  color: inherit;
  cursor: help;
`;

export { ReceivesRow, InfoIconWrapper };
